import React, {useEffect, useMemo, useState} from "react";
import tooltipIcon from "../../../assets/newIcons/tooltip.svg";
import arrowIcon from "../../../assets/icons/arrow-down-circle.svg";
import arrowBlueIcon from "../../../assets/icons/arrow-blue.svg";
import tickBlueIcon from "../../../assets/icons/tick-circle-blue.svg";
import {dollarUS} from "../../../utils/helpers/string";
import "react-tooltip/dist/react-tooltip.css";
import {Tooltip} from "react-tooltip";
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import {Pagination, Navigation} from "swiper/modules";
import {useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {setPlanType} from "../../../Redux/PlanSectionSlice";

function PlansTable({plansData, activeStep, activeTab, selectedCategory, handleScrollToCheckout, allPlans, uniqueAccountSizes, setSwiperRef, activeIndex, setActiveIndex}) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPlanType(selectedCategory === "Swing" ? "Swing" : selectedCategory));
  }, [selectedCategory, activeStep, activeTab]);

  const {planType} = useSelector((state) => state.planSection);

  console.log("PlansData:", plansData);

  const planKeys = ["Leverage", "Sim Profit Target", "Max Sim Drawdown", "Max Daily Drawdown", "Max Sim Trading Days", "Analyst Performance Fee"];
  const infoKeys = [
    {key: "Leverage", path: "https://help.alphacapitalgroup.uk/en/articles/6934203-what-is-leverage-and-what-leverage-is-offered-during-the-assessment-and-qualified-analyst-accounts"},
    {key: "Sim Profit Target", path: "https://help.alphacapitalgroup.uk/en/articles/6933910-is-there-a-minimum-target-required-on-a-qualified-analyst-account-before-i-can-receive-a-performance-fee"},
    {key: "Max Sim Drawdown", path: "https://help.alphacapitalgroup.uk/en/articles/6934220-what-is-the-maximum-total-loss"},
    {key: "Max Daily Drawdown", path: "https://help.alphacapitalgroup.uk/en/articles/6934210-what-are-the-daily-risk-limits-and-how-do-they-work"},
    {key: "Max Sim Trading Days", path: "https://help.alphacapitalgroup.uk/en/articles/6934224-what-are-the-minimum-and-maximum-trading-days-for-the-assessment"},
    {key: "Analyst Performance Fee", path: "https://help.alphacapitalgroup.uk/en/articles/6933755-how-do-i-get-paid-performance-fees"},
  ];
  const newMappedData = plansData?.flatMap((plan) => {
    const baseObj = {
      Leverage: `1:${plan["Leverage"]}`,
      "Max Sim Trading Days": "Unlimited",
      "Sim Profit Target": `${dollarUS(plan["account_balance"] / 10)} (10%)`,
      "Analyst Performance Fee": "NA",
      "Max Sim Drawdown": `${dollarUS(plan["account_balance"] * 0.06)} (6%)`,
      "Max Daily Drawdown": `${dollarUS(plan["account_balance"] * 0.04)} (4%)`,
    };

    if (activeStep === 1) {
      const secondObj = {
        ...baseObj,
        "Max Sim Trading Days": "NA",
        "Sim Profit Target": `NA`,
        "Analyst Performance Fee": "80%",
      };
      return [baseObj, secondObj];
    }

    if (activeStep === 2) {
      const swingFirstObj = {
        ...baseObj,
        Leverage: `up to 1:30`,
        "Max Sim Drawdown": `10% (${dollarUS(plan["account_balance"] * 0.1)})`,
        "Max Daily Drawdown": "5%",
      };
      const swingSecondObj = {
        ...baseObj,
        Leverage: `up to 1:30`,
        "Max Sim Trading Days": "Unlimited",
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.05)} (5%)`,
        "Analyst Performance Fee": "NA",
        "Max Sim Drawdown": `10% (${dollarUS(plan["account_balance"] * 0.1)})`,
        "Max Daily Drawdown": "5%",
      };
      const swingThirdObj = {
        ...baseObj,
        Leverage: `up to 1:30`,
        "Max Sim Trading Days": "NA",
        "Sim Profit Target": `NA`,
        "Analyst Performance Fee": "80%",
        "Max Sim Drawdown": `10% (${dollarUS(plan["account_balance"] * 0.1)})`,
        "Max Daily Drawdown": "5%",
      };

      if (selectedCategory === "Swing") {
        return [swingFirstObj, swingSecondObj, swingThirdObj];
      }

      const firstObjNew = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.08)} (8%)`,
        "Max Sim Drawdown": `8% (${dollarUS(plan["account_balance"] * 0.08)})`,
        "Max Daily Drawdown": "4%",
      };
      const secondObjNew = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "Unlimited",
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.05)} (5%)`,
        "Analyst Performance Fee": "NA",
        "Max Sim Drawdown": `8% (${dollarUS(plan["account_balance"] * 0.08)})`,
        "Max Daily Drawdown": "4%",
      };
      const thirdObjNew = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "NA",
        "Sim Profit Target": `NA`,
        "Analyst Performance Fee": "80%",
        "Max Daily Drawdown": "4%",
        "Max Sim Drawdown": `8% (${dollarUS(plan["account_balance"] * 0.08)})`,
      };

      if (plan["profit_target_in_percent"] === 8 && selectedCategory === "Alpha Pro8%") {
        return [firstObjNew, secondObjNew, thirdObjNew];
      }

      const firstObj = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Drawdown": `10% (${dollarUS(plan["account_balance"] * 0.1)})`,
        "Max Daily Drawdown": "5%",
      };
      const secondObj = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "Unlimited",
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.05)} (5%)`,
        "Analyst Performance Fee": "NA",
        "Max Sim Drawdown": `10% (${dollarUS(plan["account_balance"] * 0.1)})`,
        "Max Daily Drawdown": "5%",
      };
      const thirdObj = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "NA",
        "Sim Profit Target": `NA`,
        "Analyst Performance Fee": "80%",
        "Max Daily Drawdown": "5%",
        "Max Sim Drawdown": `10% (${dollarUS(plan["account_balance"] * 0.1)})`,
      };

      if (selectedCategory === "Alpha Pro10%") {
        return [firstObj, secondObj, thirdObj];
      }

      const firstObjNew1 = {
        ...baseObj,
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.06)} (6%)`,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Drawdown": `6% (${dollarUS(plan["account_balance"] * 0.06)})`,
        "Max Daily Drawdown": "3%",
      };
      const secondObjNew1 = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "Unlimited",
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.06)} (6%)`,
        "Analyst Performance Fee": "NA",
        "Max Sim Drawdown": `6% (${dollarUS(plan["account_balance"] * 0.06)})`,
        "Max Daily Drawdown": "3%",
      };
      const thirdObjNew1 = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "NA",
        "Sim Profit Target": `NA`,
        "Analyst Performance Fee": "80%",
        "Max Daily Drawdown": "3%",
        "Max Sim Drawdown": `6% (${dollarUS(plan["account_balance"] * 0.06)})`,
      };

      if (plan["profit_target_in_percent"] === 6 && selectedCategory === "Alpha Pro6%") {
        return [firstObjNew1, secondObjNew1, thirdObjNew1];
      }
    }

    if (activeStep === 3) {
      const firstObj = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "Unlimited",
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.08)} (8%)`,
        "Analyst Performance Fee": "NA",
        "Hold Through High Impact News": "Yes",
        "Max Sim Drawdown": `6% (${dollarUS((plan["account_balance"] * 0.6) / 10)})`,
        "Max Daily Drawdown": `4% (${dollarUS((plan["account_balance"] * 0.4) / 10)})`,
      };
      const secondObj = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "Unlimited",
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.04)} (4%)`,
        "Analyst Performance Fee": "NA",
        "Hold Through High Impact News": "Yes",
        "Max Sim Drawdown": `6% (${dollarUS((plan["account_balance"] * 0.6) / 10)})`,
        "Max Daily Drawdown": `4% (${dollarUS((plan["account_balance"] * 0.4) / 10)})`,
      };
      const thirdObj = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "Unlimited",
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.04)} (4%)`,
        "Analyst Performance Fee": "NA",
        "Hold Through High Impact News": "Yes",
        "Max Sim Drawdown": `6% (${dollarUS((plan["account_balance"] * 0.6) / 10)})`,
        "Max Daily Drawdown": `4% (${dollarUS((plan["account_balance"] * 0.4) / 10)})`,
      };
      const forthObj = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "NA",
        "Sim Profit Target": `NA`,
        "Analyst Performance Fee": "80%",
        "Hold Through High Impact News": "Yes (5 min)",
        "Max Sim Drawdown": `6% (${dollarUS((plan["account_balance"] * 0.6) / 10)})`,
        "Max Daily Drawdown": `4% (${dollarUS((plan["account_balance"] * 0.4) / 10)})`,
      };

      return [firstObj, secondObj, thirdObj, forthObj];
    }

    if (!(activeStep === 2 && ["Alpha Pro8%", "Alpha Pro6%"].includes(selectedCategory))) {
      return [baseObj];
    }
    return [];
  });

  // Fixed filteredPlansNew logic
  const filteredPlansNew = allPlans.filter((plan) => {
    if (selectedCategory === "Alpha Pro8%") {
      return plan.profit_target_in_percent === 8 && plan.steps === activeStep;
    } else if (selectedCategory === "Alpha Pro6%") {
      return plan.profit_target_in_percent === 6 && plan.steps === activeStep;
    } else if (selectedCategory === "Alpha Pro10%") {
      return plan.profit_target_in_percent === 8 && plan.steps === activeStep;
    } else if (selectedCategory === "Swing") {
      return plan.plan_type === "Swing" && plan.steps === activeStep;
    } else {
      return plan.steps === activeStep;
    }
  });

  console.log("filteredPlansNew:", filteredPlansNew, "allPlans:", allPlans);

  const mobileData = filteredPlansNew?.flatMap((plan) => {
    const baseObj = {
      Leverage: `1:${plan["Leverage"]}`,
      "Max Sim Trading Days": "Unlimited",
      "Sim Profit Target": `${dollarUS(plan["account_balance"] / 10)} (10%)`,
      "Analyst Performance Fee": "NA",
      "Max Sim Drawdown": `${dollarUS(plan["account_balance"] * 0.06)} (6%)`,
      "Max Daily Drawdown": `${dollarUS(plan["account_balance"] * 0.04)} (4%)`,
    };

    if (activeStep === 1) {
      const secondObj = {
        ...baseObj,
        "Max Sim Trading Days": "NA",
        "Sim Profit Target": `NA`,
        "Analyst Performance Fee": "80%",
      };
      return [baseObj, secondObj];
    }

    if (activeStep === 2) {
      const swingFirstObj = {
        ...baseObj,
        "Max Sim Drawdown": `10% (${dollarUS(plan["account_balance"] * 0.1)})`,
        "Max Daily Drawdown": "5%",
      };
      const swingSecondObj = {
        ...baseObj,
        Leverage: `up to 1:30`,
        "Max Sim Trading Days": "Unlimited",
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.05)} (5%)`,
        "Analyst Performance Fee": "NA",
        "Max Sim Drawdown": `10% (${dollarUS(plan["account_balance"] * 0.1)})`,
        "Max Daily Drawdown": "5%",
      };
      const swingThirdObj = {
        ...baseObj,
        "Max Sim Trading Days": "NA",
        "Sim Profit Target": `NA`,
        "Analyst Performance Fee": "80%",
        "Max Sim Drawdown": `10% (${dollarUS(plan["account_balance"] * 0.1)})`,
        "Max Daily Drawdown": "5%",
      };

      if (selectedCategory === "Swing") {
        return [swingFirstObj, swingSecondObj, swingThirdObj];
      }

      const firstObjNew1 = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.06)} (6%)`,
        "Max Sim Drawdown": `6% (${dollarUS(plan["account_balance"] * 0.06)})`,
        "Max Daily Drawdown": "3%",
      };
      const secondObjNew1 = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "Unlimited",
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.06)} (6%)`,
        "Analyst Performance Fee": "NA",
        "Max Sim Drawdown": `6% (${dollarUS(plan["account_balance"] * 0.06)})`,
        "Max Daily Drawdown": "3%",
      };
      const thirdObjNew1 = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "NA",
        "Sim Profit Target": `NA`,
        "Analyst Performance Fee": "80%",
        "Max Daily Drawdown": "3%",
        "Max Sim Drawdown": `6% (${dollarUS(plan["account_balance"] * 0.06)})`,
      };

      if (selectedCategory === "Alpha Pro6%") {
        return [firstObjNew1, secondObjNew1, thirdObjNew1];
      }

      const firstObjNew = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.08)} (8%)`,
        "Max Sim Drawdown": `8% (${dollarUS(plan["account_balance"] * 0.08)})`,
        "Max Daily Drawdown": "4%",
      };
      const secondObjNew = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "Unlimited",
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.05)} (5%)`,
        "Analyst Performance Fee": "NA",
        "Max Sim Drawdown": `8% (${dollarUS(plan["account_balance"] * 0.08)})`,
        "Max Daily Drawdown": "4%",
      };
      const thirdObjNew = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "NA",
        "Sim Profit Target": `NA`,
        "Analyst Performance Fee": "80%",
        "Max Daily Drawdown": "4%",
        "Max Sim Drawdown": `8% (${dollarUS(plan["account_balance"] * 0.08)})`,
      };

      if (selectedCategory === "Alpha Pro8%") {
        return [firstObjNew, secondObjNew, thirdObjNew];
      }

      const firstObj = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Drawdown": `10% (${dollarUS(plan["account_balance"] * 0.1)})`,
        "Max Daily Drawdown": "5%",
      };
      const secondObj = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "Unlimited",
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.05)} (5%)`,
        "Analyst Performance Fee": "NA",
        "Max Sim Drawdown": `10% (${dollarUS(plan["account_balance"] * 0.1)})`,
        "Max Daily Drawdown": "5%",
      };
      const thirdObj = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "NA",
        "Sim Profit Target": `NA`,
        "Analyst Performance Fee": "80%",
        "Max Daily Drawdown": "5%",
        "Max Sim Drawdown": `10% (${dollarUS(plan["account_balance"] * 0.1)})`,
      };

      if (selectedCategory === "Alpha Pro10%") {
        return [firstObj, secondObj, thirdObj];
      }
    }

    if (activeStep === 3) {
      const firstObj = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "Unlimited",
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.08)} (8%)`,
        "Analyst Performance Fee": "NA",
        "Hold Through High Impact News": "Yes",
        "Max Sim Drawdown": `6% (${dollarUS((plan["account_balance"] * 0.6) / 10)})`,
        "Max Daily Drawdown": `4% (${dollarUS((plan["account_balance"] * 0.4) / 10)})`,
      };
      const secondObj = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "Unlimited",
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.04)} (4%)`,
        "Analyst Performance Fee": "NA",
        "Hold Through High Impact News": "Yes",
        "Max Sim Drawdown": `6% (${dollarUS((plan["account_balance"] * 0.6) / 10)})`,
        "Max Daily Drawdown": `4% (${dollarUS((plan["account_balance"] * 0.4) / 10)})`,
      };
      const thirdObj = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "Unlimited",
        "Sim Profit Target": `${dollarUS(plan["account_balance"] * 0.04)} (4%)`,
        "Analyst Performance Fee": "NA",
        "Hold Through High Impact News": "Yes",
        "Max Sim Drawdown": `6% (${dollarUS((plan["account_balance"] * 0.6) / 10)})`,
        "Max Daily Drawdown": `4% (${dollarUS((plan["account_balance"] * 0.4) / 10)})`,
      };
      const forthObj = {
        ...baseObj,
        Leverage: `up to 1:${plan["Leverage"]}`,
        "Max Sim Trading Days": "NA",
        "Sim Profit Target": `NA`,
        "Analyst Performance Fee": "80%",
        "Hold Through High Impact News": "Yes (5 min)",
        "Max Sim Drawdown": `6% (${dollarUS((plan["account_balance"] * 0.6) / 10)})`,
        "Max Daily Drawdown": `4% (${dollarUS((plan["account_balance"] * 0.4) / 10)})`,
      };
      return [firstObj, secondObj, thirdObj, forthObj];
    }

    return [baseObj];
  });

  const planDescriptions = {
    Leverage:
      "Leverage is a financial tool that allows traders to control a larger position size with a smaller amount of capital. It magnifies both potential profits and potential losses. @ Please trade responsibly and be aware of the risks to your trading performance associated with leverage. Although no capital is at risk on our assessments or Qualified Analyst accounts, leverage can have a significant impact on your trading strategy.",
    "Max Sim Trading Days": "There are no maximum trading days imposed during the Assessment stages. You can trade as many days as needed to complete each phase successfully.",
    "Sim Profit Target": "To advance through the stages or reach the analyst account, the profit target must be met at each stage.",
    "Analyst Performance Fee":
      "Performance fees on qualified analyst trader accounts are processed as follows: traders can request a payout whenever they desire, provided they adhere to the 40% Best Day Rule and have a minimum of 2% of gross profits on the account balance. 40% Best Day Rule: This rule states that no single trading day should contribute more than 40% of the total generated profits. For example, if you earn $1,000 on a particular trading day, you will be eligible to request a withdrawal only after your account balance exceeds $2,500. This ensures that the $1,000 trading day accounts for less than 40% of the total profits in the account balance. Similarly, if your total profits are $4,000, this means that your best day should be equal to or below $1,600 for you to be eligible to request a withdrawal.",
    "Max Sim Drawdown":
      "The maximum permissible loss is defined by a trailing drawdown, restricted to a 6% reduction from the account’s high water-mark (maximum account balance achieved on the account). For clarity, on a $100,000 Assessment, the initial maximum drawdown of -6% for a $100,000 account is $94,000. As the maximum drawdown is trailing based on the high-water mark, if the account reaches $102,000, the new maximum drawdown will be set at $96,000. This process will continue until the account reaches a high-water mark equal to the trailing drawdown of 6%. In other words, once the balance reaches $106,000, the trailing drawdown will remain fixed at the initial balance of $100,000, and won't be moved further anymore.",
    "Max Daily Drawdown":
      "Our daily loss limit is calculated over the highest end-of-day balance or equity, whichever is greater. This end-of-day balance or equity is the account status at the close of the daily candle on broker time, which is at 00:00 GMT+3. For example, if your account balance is $100,000 and your equity is $101,000 at the end of the daily candle, your maximum daily risk for the next day will be 4% of the equity (since $101,000 equity is greater than the $100,000 balance). This results in a maximum daily loss of $4,040. Consequently, your maximum drawdown threshold will be $96,960 (calculated as the equity at the start of the trading day, $101,000, minus the 4% maximum daily loss, $4,040).",
    "Max Sim Capital Growth":
      "The maximum virtual capital growth on the Alpha Pro Plan is $2 million. Traders who achieve a 10% virtual capital growth on their trading account can request scaling. The scaling amount will be 10% of the initial account balance, allowing the trader to request performance fees and scale simultaneously. @ Requesting a Scale up with Alpha Capital Group To request account scaling your account must be at the withdrawal stage. Kindly add to the 'Reason/Notes' section of the Performance Fee Request that you would like to join the scaling plan and scale up your account. Additionally, please send an email to payments@alphacapitalgroup.uk explicitly stating your request for a scale-up of the account. Please allow a timeframe of 24-48 business hours for the completion of this request. Please note that your new scaled account requires a minimum of 5 trading days before the first Performance Fee is applicable.​To scale the account, each time there must be a 10% gain achieved of the account balance, at the time of requesting scaling, the 10% gain must be present in the account (previous withdrawals are not counted)",
    "Minimum Sim Trading Days":
      "There are imposed minimum trading days for each of the assessment stage accounts. If you meet the profit target before this time you will need to continue trading until you meet this criteria.",
    "0% Commissions":
      "At Alpha Capital Group we currently offer 2 account types. Standard Assessment and Raw assessment. You can select which one you require at Checkout. @ For our Standard Assessment, please note that there are no commission fees applicable to trades across all asset classes.",
    "Hold Through High Impact News":
      "In Alpha One Assessment phase you can trade without any restrictions for all news releases. After you pass the Assessment phase and become a Qualified Trader you are allowed to trade freely during all news releases for a max period of 5 mins.",
    "Hold Over The Weekend": "In Alpha One plan Holding trades over the weekend is allowed at all stages.",
    "Payout On Demand": "In Alpha One you can request payout on demand but must have a consistency score of 50% and must have achieved a minimum 2% sim profit target",
  };
  const planStepTwoDescriptions = {
    "Max Daily Drawdown": `${
      selectedCategory === "Alpha Pro8%"
        ? "Our daily loss limit is determined based on 4% of your starting balance for each trading day. This starting balance is the account balance at the close of the daily candle on broker time, which is at 00:00 GMT+3. The open equity (including any floating gains or losses) from the previous trading day is not factored into the maximum daily loss calculation. This means that even if your balance is $100,000 and equity is $101,000, the minimum equity requirement remains at $96,000, allowing you to theoretically lose up to $5,000 during the day, taking into account the floating unrealized profit or loss."
        : selectedCategory === "Alpha Pro6%"
          ? "Our daily loss limit is determined based on 3% of your starting balance for each trading day. This starting balance is the account balance at the close of the daily candle on broker time, which is at 00:00 GMT+3. The open equity (including any floating gains or losses) from the previous trading day is not factored into the maximum daily loss calculation. This means that even if your balance is $100,000 and equity is $101,000, the minimum equity requirement remains at $97,000, allowing you to theoretically lose up to $4,000 during the day, taking into account the floating unrealized profit or loss."
          : "Our daily loss limit is determined based on 5% of your starting balance for each trading day. This starting balance is the account balance at the close of the daily candle on broker time, which is at 00:00 GMT+3. The open equity (including any floating gains or losses) from the previous trading day is not factored into the maximum daily loss calculation. This means that even if your balance is $100,000 and equity is $101,000, the minimum equity requirement remains at $95,000, allowing you to theoretically lose up to $6,000 during the day, taking into account the floating unrealized profit or loss."
    } `,
    "Max Sim Drawdown": `${
      selectedCategory === "Alpha Pro8%"
        ? "The maximum permissible loss is defined by a fixed absolute drawdown, restricted to a 8% reduction from the initial starting balance.For clarity, on a $100,000 Assessment, the allowable loss threshold is set at $8,000. Should the account balance or equity decline below $92,000 at any point, this criterion is considered breached. Consistent with our policies regarding maximum daily losses, should the equity dip to the predetermined minimum level, the system will initiate an automatic closure of all trades, resulting in the termination of the account."
        : selectedCategory === "Alpha Pro6%"
          ? "The maximum permissible loss is defined by a fixed absolute drawdown, restricted to a 6% reduction from the initial starting balance.For clarity, on a $100,000 Assessment, the allowable loss threshold is set at $6,000. Should the account balance or equity decline below $94,000 at any point, this criterion is considered breached. Consistent with our policies regarding maximum daily losses, should the equity dip to the predetermined minimum level, the system will initiate an automatic closure of all trades, resulting in the termination of the account."
          : "The maximum permissible loss is defined by a fixed absolute drawdown, restricted to a 10% reduction from the initial starting balance.For clarity, on a $100,000 Assessment, the allowable loss threshold is set at $10,000. Should the account balance or equity decline below $90,000 at any point, this criterion is considered breached. Consistent with our policies regarding maximum daily losses, should the equity dip to the predetermined minimum level, the system will initiate an automatic closure of all trades, resulting in the termination of the account."
    }`,
    "Hold Through High Impact News":
      "During the Assessment stage of the Alpha Pro accounts you can trade freely during all news releases. After you pass the Assessment and are a Qualified Trader you should be careful when trading during news releases. Swing accounts can trade freely during all news events.",
    "Hold Over The Weekend":
      "Pro Plan: @ Assessment stage : Holding trades over the weekend allowed.@ Qualified Analyst Account: Holding trades over the weekend not allowed. @ Swing plan: @ Holding trades over the weekend is allowed at all stages. @ However, it is essential to note that this will entail the accrual of swap fees.",
  };
  const planStepTwoThreeDescriptions = {
    "Analyst Performance Fee": `${
      selectedCategory === "Swing"
        ? "Performance fees on qualified analyst trader accounts are processed as follows: traders can request a payout whenever they desire, provided they adhere to the 40% Best Day Rule and have a minimum of 2% of gross profits on the account balance. 40% Best Day Rule: This rule states that no single trading day should contribute more than 40% of the total generated profits. For example, if you earn $1,000 on a particular trading day, you will be eligible to request a withdrawal only after your account balance exceeds $2,500. This ensures that the $1,000 trading day accounts for less than 40% of the total profits in the account balance. Similarly, if your total profits are $4,000, this means that your best day should be equal to or below $1,600 for you to be eligible to request a withdrawal."
        : "Performance fees on qualified analyst trader accounts are processed as follows: Requests are available bi-weekly, starting 14 days after your initial trade on your qualified analyst trader account. You can find this date in the account metrics section of your trader's dashboard The minimum performance fee amount is $100. ($100 gross - $80 net) To qualify for a withdrawal, a minimum profit of $100 must be realized on the account. All performance fee requests will be processed and paid within 2 business days For your first performance fee request, a minimum of 5 trading days is required."
    }`,
    "Payout On Demand": "",
  };
  const planStepThreeDescriptions = {
    "Max Sim Drawdown":
      "The maximum permissible loss is defined by a fixed absolute drawdown, restricted to a 6% reduction from the initial starting balance. For clarity, on a $100,000 Assessment, the allowable loss threshold is set at $6,000. Should the account balance or equity decline below $94,000 at any point, this criterion is considered breached. Consistent with our policies regarding maximum daily losses, should the equity dip to the predetermined minimum level, the system will initiate an automatic closure of all trades, resulting in the termination of the account.",
    "Max Daily Drawdown":
      "Our daily loss limit is calculated over the highest end-of-day balance or equity, whichever is greater. This end-of-day balance or equity is the account status at the close of the daily candle on broker time, which is at 00:00 GMT+3. For example, if your account balance is $100,000 and your equity is $101,000 at the end of the daily candle, your maximum daily risk for the next day will be 4% of the equity (since $101,000 equity is greater than the $100,000 balance). This results in a maximum daily loss of $4,040. Consequently, your maximum drawdown threshold will be $96,960 (calculated as the equity at the start of the trading day, $101,000, minus the 4% maximum daily loss, $4,040).",
  };

  const [expandedRow, setExpandedRow] = useState(null);
  const [expandedDescription, setExpandedDescription] = useState("");

  console.log("selectedCategory", selectedCategory);

  useEffect(() => {
    setExpandedRow(null);
  }, [activeStep, activeTab]);

  const handleRowClick = (index, key) => {
    setExpandedRow((prev) => (prev === index ? null : index));
    if (activeStep !== 1 && (key === "Analyst Performance Fee" || key === "Payout On Demand")) {
      setExpandedDescription(planStepTwoThreeDescriptions[key] || "No description available.");
    } else if (activeStep === 2 && (key === "Max Daily Drawdown" || key === "Max Sim Drawdown" || key === "Hold Over The Weekend" || key === "Hold Through High Impact News")) {
      setExpandedDescription(planStepTwoDescriptions[key] || "No description available.");
    } else if (activeStep === 3 && (key === "Max Daily Drawdown" || key === "Max Sim Drawdown")) {
      setExpandedDescription(planStepThreeDescriptions[key] || "No description available.");
    } else {
      setExpandedDescription(planDescriptions[key] || "No description available.");
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 750);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 750);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const location = useLocation();

  const selectedAccountSize = useMemo(() => {
    return uniqueAccountSizes?.[activeIndex] ?? uniqueAccountSizes?.[0];
  }, [activeIndex, uniqueAccountSizes]);

  const currentPrice = useMemo(() => {
    if (!plansData?.[0]) return 0;
    return selectedCategory === "Alpha Pro10%" ? dollarUS(Number(plansData[0]?.price_alpha_pro_10per)) : dollarUS(Number(plansData[0]?.Price));
  }, [plansData, selectedCategory, selectedAccountSize]);

  console.log("selectedAccountSize", selectedAccountSize, currentPrice);

  return (
    <div className="plansTable_wrapper">
      <div className="plans_table laptop">
        <div className="planDetails_wrapper">
          <div className="planDetails_inner_main">
            {activeStep === 1 && (
              <>
                <div className="steps_info">
                  <span className="gradientText">{"1 Step"}</span>
                  <div className="plan_name">
                    <h3>{"Analyst Assessment"}</h3>
                  </div>
                </div>
                <div className="steps_info">
                  <span className="gradientText">{"Qualified"}</span>
                  <div className="plan_name">
                    <h3>{"Qualified Analyst"}</h3>
                  </div>
                </div>
              </>
            )}

            {activeStep === 2 && (
              <>
                <div className="steps_info">
                  <span className="gradientText">{"1 Step"}</span>
                  <div className="plan_name">
                    <h3>{"Analyst Assessment"}</h3>
                  </div>
                </div>
                <div className="steps_info">
                  <span className="gradientText">{"2 Step"}</span>
                  <div className="plan_name">
                    <h3>{"Analyst Assessment"}</h3>
                  </div>
                </div>
                <div className="steps_info">
                  <span className="gradientText">{"Qualified"}</span>
                  <div className="plan_name">
                    <h3>{"Qualified Analyst"}</h3>
                  </div>
                </div>
              </>
            )}

            {activeStep === 3 && (
              <>
                <div className="steps_info">
                  <span className="gradientText">{"1 Step"}</span>
                  <div className="plan_name">
                    <h3>{"Analyst Assessment"}</h3>
                  </div>
                </div>
                <div className="steps_info">
                  <span className="gradientText">{"2 Step"}</span>
                  <div className="plan_name">
                    <h3>{"Analyst Assessment"}</h3>
                  </div>
                </div>
                <div className="steps_info">
                  <span className="gradientText">{"3 Step"}</span>
                  <div className="plan_name">
                    <h3>{"Analyst Assessment"}</h3>
                  </div>
                </div>
                <div className="steps_info">
                  <span className="gradientText">{"Qualified"}</span>
                  <div className="plan_name">
                    <h3>{"Qualified Analyst"}</h3>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="plan_highlights">
            {activeStep === 1 && (
              <>
                <div>
                  <img
                    src={tickBlueIcon}
                    alt=""
                  />
                  <p>No Profit Cap</p>
                </div>
                <div>
                  <img
                    src={tickBlueIcon}
                    alt=""
                  />
                  <p>Payout-on-demand</p>
                </div>
                <div>
                  <img
                    src={tickBlueIcon}
                    alt=""
                  />
                  <p>Quickest way to become an Alpha Trader</p>
                </div>
              </>
            )}
            {activeStep === 2 && (
              <>
                <div>
                  <img
                    src={tickBlueIcon}
                    alt=""
                  />
                  <p>No Profit Cap</p>
                </div>
                <div>
                  <img
                    src={tickBlueIcon}
                    alt=""
                  />
                  {selectedCategory === "Swing" ? <p>Payout-on-demand</p> : <p>Payout biweekly or On-demand</p>}
                </div>
              </>
            )}
            {activeStep === 3 && (
              <>
                <div>
                  <img
                    src={tickBlueIcon}
                    alt=""
                  />
                  <p>No Profit Cap</p>
                </div>
                <div>
                  <img
                    src={tickBlueIcon}
                    alt=""
                  />
                  <p>Payout biweekly or On-demand</p>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="tableWrapper">
          <div className="tableSteps_header">
            <div className="blank_div"></div>
            <div className="tableSteps"></div>
          </div>
          <div className="tableBox">
            <div className="table_header">
              <div className="table_head keys"></div>
              <div className="table_head">
                {activeStep === 1 && (
                  <>
                    <h3 className="stepHeader custom">1 Step</h3>
                    <h3 className="stepHeader custom">Qualified</h3>
                  </>
                )}
                {activeStep === 2 && (
                  <>
                    <h3 className="stepHeader custom">1 Step</h3>
                    <h3 className="stepHeader custom">2 Step</h3>
                    <h3 className="stepHeader custom">Qualified</h3>
                  </>
                )}
                {activeStep === 3 && (
                  <>
                    <h3 className="stepHeader custom">1 Step</h3>
                    <h3 className="stepHeader custom">2 Step</h3>
                    <h3 className="stepHeader custom">3 Step</h3>
                    <h3 className="stepHeader custom">Qualified</h3>
                  </>
                )}
              </div>
            </div>
            <div className="table_rows">
              {planKeys.map((key, index) => (
                <React.Fragment key={index}>
                  <div
                    className={`table_row ${index % 2 !== 0 ? "table_row_white" : ""}`}
                    onMouseEnter={() => handleRowClick(index, key)}
                  >
                    <div className="table_row_data keys">
                      {key}
                      {/* <a
                        data-tooltip-id={`tooltip-${index}`}
                        data-tooltip-html={`<b>${key}</b><br>${
                          expandedDescription
                            ? expandedDescription
                                .split("@")
                                .map((part) => part.trim())
                                .join("<br>")
                            : "No details available"
                        }`}
                      >
                        {isMobile ? (
                          <img
                            src={arrowIcon}
                            alt="arrow"
                            className={`arrow-icon ${expandedRow === index ? "expanded" : ""}`}
                          />
                        ) : (
                          <img
                            src={tooltipIcon}
                            alt="arrow"
                            style={{marginTop: "3px"}}
                            className={`arrow-icon ${expandedRow === index ? "expanded" : ""}`}
                          />
                        )}
                      </a> */}

                      {/* <Tooltip
                        id={`tooltip-${index}`}
                        html={true}
                        place="bottom"
                        noArrow={true}
                      /> */}
                      <a
                        onClick={(e) => {
                          e.stopPropagation();
                          const linkObj = infoKeys.find((info) => info.key === key);
                          if (linkObj && linkObj.path) {
                            window.open(linkObj.path, "_blank");
                          } else {
                            console.warn(`No link found for key: ${key}`);
                          }
                        }}
                        style={{cursor: "pointer"}}
                      >
                        {isMobile ? (
                          <img
                            src={arrowIcon}
                            alt="arrow"
                            className={`arrow-icon ${expandedRow === index ? "expanded" : ""}`}
                          />
                        ) : (
                          <img
                            src={tooltipIcon}
                            alt="arrow"
                            style={{marginTop: "3px"}}
                            className={`arrow-icon ${expandedRow === index ? "expanded" : ""}`}
                          />
                        )}
                      </a>
                    </div>
                    {newMappedData.map((plan, planIndex) => (
                      <div
                        key={planIndex}
                        className="table_row_data custom"
                      >
                        {plan[key] !== undefined ? plan[key] : "N/A"}
                      </div>
                    ))}
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>

        <div className="table_footer">
          <h3>
            {selectedCategory === "Alpha Pro8%"
              ? `Alpha Pro ${Number(plansData?.[0]?.account_balance) / 1000}K 8%`
              : selectedCategory === "Alpha Pro10%"
                ? `Alpha Pro ${Number(plansData?.[0]?.account_balance) / 1000}K 10%`
                : plansData[0].name}
          </h3>
          <div className="rightBox">
            <p>
              Assessment Price: <span style={{display: "none"}}>{selectedCategory}</span>{" "}
              <span
                translate="no"
                className="nottranslate"
              >
                {selectedCategory === "Alpha Pro10%" ? dollarUS(Number(plansData[0]?.price_alpha_pro_10per || 0)) : dollarUS(Number(plansData[0]?.Price || 0))}
              </span>
            </p>
            {/* <p>Assessment Price: {currentPrice}</p> */}
            <button
              className="normalButton"
              onClick={() => {
                if (location.pathname === "/riz") {
                  handleRedirect("https://app.alphacapitalgroup.uk/signup/RIZ");
                } else if (plansData[0]?.id) {
                  console.log("Desktop Checkout Clicked:", {
                    planId: plansData[0].id,
                    planName: plansData[0].name,
                    selectedCategory,
                    accountSize: plansData[0].account_balance,
                  });
                  handleScrollToCheckout(plansData[0].id);
                } else {
                  console.error("No valid plan ID for checkout:", {plansData});
                }
              }}
            >
              Start Alpha Capital Evaluation{" "}
              <img
                src={arrowBlueIcon}
                alt=""
              />
            </button>
          </div>
        </div>
      </div>

      <div className="mobile_plan_table">
        <Swiper
          modules={[Pagination]}
          slidesPerView={1.1}
          pagination={{clickable: true}}
          spaceBetween={"10px"}
          breakpoints={{
            640: {slidesPerView: 1.1, slidesPerGroup: 1},
            768: {slidesPerView: 1.1, slidesPerGroup: 1},
            1024: {slidesPerView: 3, slidesPerGroup: 3},
          }}
          onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
          onSwiper={setSwiperRef}
          centeredSlides={true}
          slideToClickedSlide={true}
        >
          {uniqueAccountSizes?.map((accountSize, itemIndex) => {
            const currentPlan = plansData?.find((plan) => plan?.account_balance === selectedAccountSize) || plansData[0];

            const filteredPlan = filteredPlansNew?.find((plan) => plan?.account_balance === selectedAccountSize) || currentPlan;

            console.log("currentPlan", currentPlan);

            return (
              <SwiperSlide key={itemIndex}>
                <div className="plans_table">
                  <div className="table_footer">
                    <h3>
                      {selectedCategory === "Alpha Pro8%"
                        ? `Alpha Pro ${Number(filteredPlan?.account_balance) / 1000}K 8%`
                        : selectedCategory === "Alpha Pro10%"
                          ? `Alpha Pro ${Number(filteredPlan?.account_balance) / 1000}K 10%`
                          : selectedCategory === "Swing"
                            ? `Swing ${Number(filteredPlan?.account_balance) / 1000}K 10%`
                            : filteredPlan?.name || filteredPlan?.name}
                    </h3>
                    <div className="rightBox">
                      <p>
                        Assessment Price: <span style={{display: "none"}}>{selectedCategory}</span>{" "}
                        <span
                          translate="no"
                          className="nottranslate"
                        >
                          {selectedCategory === "Alpha Pro10%" ? dollarUS(Number(filteredPlan?.price_alpha_pro_10per)) || dollarUS(Number(filteredPlan?.Price)) : dollarUS(Number(filteredPlan?.Price))}
                        </span>
                      </p>
                      {/* <p>Assessment Price: {currentPrice}</p> */}
                      <button
                        className="normalButton"
                        onClick={() => {
                          const planId = filteredPlan?.id;
                          if (planId) {
                            console.log("Mobile Checkout Clicked:", {
                              planId,
                              planName: filteredPlan?.name,
                              selectedCategory,
                              accountSize,
                            });
                            handleScrollToCheckout(planId);
                          } else {
                            console.error("No valid plan ID for checkout:", {currentPlan, filteredPlan});
                          }
                        }}
                      >
                        Start Alpha Capital Evaluation{" "}
                        <img
                          src={arrowBlueIcon}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>

                  <div className="mobileSteps">
                    {planKeys.map((key, index) => {
                      const step1Index = itemIndex * (activeStep >= 3 ? 4 : activeStep === 2 ? 3 : 2);
                      const step2Index = step1Index + 1;
                      const step3Index = step1Index + 2;
                      const step4Index = step1Index + 3;

                      const step1Value = mobileData[step1Index]?.[key] || "NA";
                      const step2Value = mobileData[step2Index]?.[key] || "NA";
                      const step3Value = activeStep >= 2 ? mobileData[step3Index]?.[key] || "NA" : null;
                      const step4Value = activeStep === 3 ? mobileData[step4Index]?.[key] || "NA" : null;

                      let areAllStepsSame =
                        activeStep === 3
                          ? step1Value === step2Value && step2Value === step3Value && step3Value === step4Value
                          : activeStep === 2
                            ? step1Value === step2Value && step2Value === step3Value
                            : step1Value === step2Value;

                      return (
                        <React.Fragment key={index}>
                          <div className={`table_row ${index % 2 !== 0 ? "table_row_white" : ""}`}>
                            <div className={`table_row_key ${expandedRow === index ? "" : ""}`}>
                              <div
                                className="key_header"
                                onClick={() => handleRowClick(index, key)}
                              >
                                <a
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const linkObj = infoKeys.find((info) => info.key === key);
                                    if (linkObj && linkObj.path) {
                                      window.open(linkObj.path, "_blank");
                                    } else {
                                      console.warn(`No link found for key: ${key}`);
                                    }
                                  }}
                                  style={{cursor: "pointer", display: "flex"}}
                                >
                                  <img
                                    src={tooltipIcon}
                                    alt="arrow"
                                    className={`arrow-icon ${expandedRow === index ? "expanded" : ""}`}
                                  />
                                </a>
                                {key}
                              </div>
                              {/* <div className="key_description">
                                {expandedDescription.split("@").map((part, index) => (
                                  <p key={index}>{part.trim()}</p>
                                ))}
                              </div> */}
                            </div>

                            <div className="table_row_values">
                              {areAllStepsSame ? (
                                <div className="table_cell">
                                  <span>{activeStep === 1 ? "1 Step / Qualified" : activeStep === 2 ? "1 Step / 2 Step / Qualified" : "1 Step / 2 Step / 3 Step / Qualified"}</span>
                                  <span>{step1Value}</span>
                                </div>
                              ) : (
                                <>
                                  <div className="table_cell">
                                    <span>1 Step</span>
                                    <span>{step1Value}</span>
                                  </div>
                                  <div className="table_cell">
                                    <span>{activeStep === 1 ? "Qualified" : "2 Step"}</span>
                                    <span>{step2Value}</span>
                                  </div>
                                  {activeStep >= 2 && (
                                    <div className="table_cell">
                                      <span>3 Step</span>
                                      <span>{step3Value}</span>
                                    </div>
                                  )}
                                  {activeStep >= 3 && (
                                    <div className="table_cell">
                                      <span>Qualified</span>
                                      <span>{step4Value}</span>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
}

export default PlansTable;
